export default "__VITE_ASSET__a5fa6624__"